// src/components/PortfolioFilters.js
import React from "react";
import "./PortfolioFilters.css";

const FILTERS = ["All", "360°", "Drone", "Video", "Photo"];

function PortfolioFilters({ active, onChange }) {
  return (
    <div className="portfolio-filters">
      {FILTERS.map((filter) => (
        <button
          key={filter}
          className={`filter-btn ${active === filter ? "active" : ""}`}
          onClick={() => onChange(filter)}
        >
          {filter}
        </button>
      ))}
    </div>
  );
}

export default PortfolioFilters;
